import {   types } from '../../actions'

function setSeasonStatus(seasons){
    const seasonStatus = [];
  
    seasons.map(function(season) {
      const s = {
        id: season.id,
        description: season.description,
        isCurrent:season.isCurrent,
        isSeasonSet:season.isSeasonSet,
        year: season.year,
      }
      seasonStatus.push(s);
    })
    return seasonStatus;
}
export default function seasonsettings (state={},action) {   
    
    const {  payload } = action      
    
    switch(action.type) {
       
        case types.Season.FETCH_ACTIVE_SEASONS: {     
              
            const { data } = payload
       
            if (data) { 
              
                const defaultSeason = data[0];
                const defaultId   = parseInt(defaultSeason.id);
                const seasonyears = defaultSeason.description;
                const seasonstatus = setSeasonStatus(data);

                return Object.assign({},state,{
                        values: {
                            settingsseason:defaultId,
                            seasonyears,
                            defaultSeason,
                            seasonstatus
                        },
                        fields: {
                            settingsseason:defaultId,
                            seasonyears,
                            defaultSeason,
                            seasonstatus
                        }
                    }
                ) 
            }
            else {
                return state
            }
        }
        case types.Season.FETCH_NEW_SEASON: {     
              
            const { data } = payload;
            if (data) {            
                const newseason = data;
                return { ...state,
                    values: {
                        ...state.values,
                        isNewSeason: true,
                        newseason
                    },
                    fields: {
                        ...state.fields,
                        isNewSeason: true,
                        newseason
                    }
                }
            }
            else {
                return state
            }
        }
        case  types.Season.TRIGGER_SEASON: {
            const { data } = payload
            if (data) {
               const defaultSeason = data[data.length - 1]
               const newState = {
                    isNewSeason: false,
                    settingsseason: parseInt(defaultSeason.id),
                    seasonyears:  defaultSeason.description,
                    defaultSeason
               }
               return Object.assign({},state,{
                values: {
                  ...newState
                },
                fields: {
                  ...newState
                }
              }
              )
            }
            else {
                return state
            }
        }
        default: return state
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/forms/seasonsettings.js